import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import DebouncedButton from '../Button/Button';
import { ERROR, HOME } from '../../constants/routes';
import './MyError.scss';
import { t } from '../../i18n/i18n';

const MyError = () => {
  const history = useHistory();
  const { status } = useParams();
  const statuses = ['404', '500', 'INTEGRATION_ERROR'];

  useEffect(() => {
    if (!statuses.includes(status)) {
      history.replace(`${ERROR}/404`);
    }
  }, []);

  return (
    statuses.includes(status) && (
      <div className="error-page-container d-flex flex-column py-5 mx-auto">
        <h2 className="font-weight-bold error-page-text text-center">
          {status === '404' || !status ? t('ERROR_PAGE_NOT_FOUND') : t('ERROR_WE_HAD_A_PROBLEM')}
        </h2>
        <div className="text-center">
          <DebouncedButton
            className="mr-2 rounded-0 font-weight-600 text-muted"
            onClick={() => history.goBack()}
            size="sm"
          >
            {t('ERROR_GO_BACK')}
          </DebouncedButton>
          <DebouncedButton
            className="rounded-0 font-weight-600 text-white bg-blue-principal"
            onClick={() => history.push(HOME)}
            size="sm"
          >
            {t('ERROR_GO_TO_HOME')}
          </DebouncedButton>
          <img src={`/errors/${status || '404'}.svg`} alt="error" className="w-100 mt-2" />
        </div>
      </div>
    )
  );
};

export default MyError;
